export default __webpack_public_path__ + "static/WorkPlay_logo-a11dede591c6015f4e0c1bb880066269.png";